export enum PaymentSystems {
  JCC = 'JCC',
  JCC2 = 'JCC2',
  PBT = 'PBT',
  Six = 'SIX',
  Viva = 'VIVA',
}
